import * as fromDatatype from '../datatype-library/index';
import { shared_audit_trail_json } from '../datatype-library/postgresql/json-datatype.model';

export interface bl_cms_event_management_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  table_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  table_name: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  audit_trail_json: shared_audit_trail_json;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  action_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  action_by_subject_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_event_management_audit_trail_RowClass implements bl_cms_event_management_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  table_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  table_name: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  audit_trail_json: shared_audit_trail_json;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  action_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  action_by_subject_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
